import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledCell = styled(Stack)({
  height: "100%",
  width: "100%",
  alignItems: "center",
  justifyContent: "center",
});
